export const getCdnPath = (path?: string | null) => {
  return path ?? '';
};
